// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__3WN8h","clickedWithMouse":"MenuLabel_clickedWithMouse__Ao4s6","isOpen":"MenuLabel_isOpen__2Jb7q"};